<template>
  <el-dialog :visible="editshow" :show-close="false" title="提示" width="30%" center>
    <el-input v-model="pwd" placeholder="请输入密码" show-password/>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeedit">取 消</el-button>
      <el-button type="primary" @click="editpwd">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { UpdatePassWord } from '@/api/user'
export default {
  name: 'Editwd',
  props: {
    date: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      pwd: '',
      editshow: null,
      id: null
    }
  },
  methods: {
    editpwd() {
      const pwdobj = {
        userId: this.id || this.date.UserId,
        pwd: this.pwd
      }
      UpdatePassWord(pwdobj).then(response => {
        location.reload()
      })
    },
    closeedit() {
      this.editshow = false
    },
    openedit(id) {
      if (id) this.id = id
      this.editshow = true
    }
  }
}
</script>

